// import React, { useState, useEffect } from "react";
// import "./EducationHistory.css";
// import HomeServices from "../../Services/HomeServices";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";

// const EducationHistory = () => {
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("primary");
//   const [applicantId, setApplicantId] = useState("");
//   const [spouseId, setSpouseId] = useState("");
//   const [spouseExists, setSpouseExists] = useState(false);
//   const navigate = useNavigate();

//   // Primary Applicant Education History Array
//   const [primaryEducationHistory, setPrimaryEducationHistory] = useState([
//     {
//       levelOfEducation: "",
//       studyName: "",
//       fromDate: "",
//       toDate: "",
//       cityOfEducation: "",
//       countryOfEducation: "",
//       nameOfInstitution: "",
//       addressOfInstitution: "",
//       designatedLearningInstituteNo: "",
//       cityOfCampusAttended: "",
//     },
//   ]);

//   const [primaryLanguageTest, setPrimaryLanguageTest] = useState({
//     languageTestTaken: "",
//     languageTestVersion: "",
//     dateOfTest: "",
//     dateOfTestResult: "",
//     languageTestCertificateNo: "",
//     CELPIPno: "",
//     speaking: "",
//     reading: "",
//     listening: "",
//     writing: "",
//     takenAnApprovedTestForFrench: "",
//   });

//   const [primaryECA, setPrimaryECA] = useState({
//     ECAOrganization: "",
//     dateECAreportIssued: "",
//     ECAcertificateNo: "",
//     ECAequivalency: "",
//   });

//   // Spouse Education History Array
//   const [spouseEducationHistory, setSpouseEducationHistory] = useState([
//     {
//       levelOfEducation: "",
//       studyName: "",
//       fromDate: "",
//       toDate: "",
//       cityOfEducation: "",
//       countryOfEducation: "",
//       nameOfInstitution: "",
//       addressOfInstitution: "",
//       designatedLearningInstituteNo: "",
//       cityOfCampusAttended: "",
//     },
//   ]);

//   const [spouseLanguageTest, setSpouseLanguageTest] = useState({
//     languageTestTaken: "",
//     languageTestVersion: "",
//     dateOfTest: "",
//     dateOfTestResult: "",
//     languageTestCertificateNo: "",
//     CELPIPno: "",
//     speaking: "",
//     reading: "",
//     listening: "",
//     writing: "",
//     takenAnApprovedTestForFrench: "",
//   });

//   const [spouseECA, setSpouseECA] = useState({
//     ECAOrganization: "",
//     dateECAreportIssued: "",
//     ECAcertificateNo: "",
//     ECAequivalency: "",
//   });

//   const fetchApplicantData = async () => {
//     try {
//       setLoading(true);
//       const res = await HomeServices.getPrimariApplicantData();
//       console.log("Education history data response:", res);

//       if (res?.status && res?.data && res.data.length > 0) {
//         const primaryData = res.data[0]?.PrimaryApplicantData;

//         if (primaryData) {
//           // Set applicant ID
//           setApplicantId(primaryData._id);

//           // Check if spouse exists
//           if (primaryData.PrimaryApplicantSpouseData?._id) {
//             setSpouseExists(true);
//             setSpouseId(primaryData.PrimaryApplicantSpouseData._id);
//           }

//           // Load primary applicant education history
//           if (
//             primaryData.educationHistory &&
//             primaryData.educationHistory.length > 0
//           ) {
//             setPrimaryEducationHistory(
//               primaryData.educationHistory.map((edu) => ({
//                 levelOfEducation: edu.levelOfEducation || "",
//                 studyName: edu.studyName || "",
//                 fromDate: edu.fromDate ? formatDate(edu.fromDate) : "",
//                 toDate: edu.toDate ? formatDate(edu.toDate) : "",
//                 cityOfEducation: edu.cityOfEducation || "",
//                 countryOfEducation: edu.countryOfEducation || "",
//                 nameOfInstitution: edu.nameOfInstitution || "",
//                 addressOfInstitution: edu.addressOfInstitution || "",
//                 designatedLearningInstituteNo:
//                   edu.designatedLearningInstituteNo || "",
//                 cityOfCampusAttended: edu.cityOfCampusAttended || "",
//               })),
//             );
//           }

//           // Load primary applicant language test data
//           if (primaryData.languageTestTaken !== undefined) {
//             setPrimaryLanguageTest({
//               languageTestTaken: primaryData.languageTestTaken || "",
//               languageTestVersion: primaryData.languageTestVersion || "",
//               dateOfTest: primaryData.dateOfTest
//                 ? formatDate(primaryData.dateOfTest)
//                 : "",
//               dateOfTestResult: primaryData.dateOfTestResult
//                 ? formatDate(primaryData.dateOfTestResult)
//                 : "",
//               languageTestCertificateNo:
//                 primaryData.languageTestCertificateNo?.toString() || "",
//               CELPIPno: primaryData.CELPIPno?.toString() || "",
//               speaking: primaryData.speaking || "",
//               reading: primaryData.reading || "",
//               listening: primaryData.listening || "",
//               writing: primaryData.writing || "",
//               takenAnApprovedTestForFrench:
//                 primaryData.takenAnApprovedTestForFrench || "",
//             });
//           }

//           // Load primary applicant ECA data
//           if (primaryData.ECAOrganization !== undefined) {
//             setPrimaryECA({
//               ECAOrganization: primaryData.ECAOrganization || "",
//               dateECAreportIssued: primaryData.dateECAreportIssued
//                 ? formatDate(primaryData.dateECAreportIssued)
//                 : "",
//               ECAcertificateNo: primaryData.ECAcertificateNo?.toString() || "",
//               ECAequivalency: primaryData.ECAequivalency?.toString() || "",
//             });
//           }

//           // Load spouse education history if exists
//           const spouseData = primaryData.PrimaryApplicantSpouseData;
//           if (spouseData) {
//             if (
//               spouseData.educationHistory &&
//               spouseData.educationHistory.length > 0
//             ) {
//               setSpouseEducationHistory(
//                 spouseData.educationHistory.map((edu) => ({
//                   levelOfEducation: edu.levelOfEducation || "",
//                   studyName: edu.studyName || "",
//                   fromDate: edu.fromDate ? formatDate(edu.fromDate) : "",
//                   toDate: edu.toDate ? formatDate(edu.toDate) : "",
//                   cityOfEducation: edu.cityOfEducation || "",
//                   countryOfEducation: edu.countryOfEducation || "",
//                   nameOfInstitution: edu.nameOfInstitution || "",
//                   addressOfInstitution: edu.addressOfInstitution || "",
//                   designatedLearningInstituteNo:
//                     edu.designatedLearningInstituteNo || "",
//                   cityOfCampusAttended: edu.cityOfCampusAttended || "",
//                 })),
//               );
//             }

//             if (spouseData.languageTestTaken !== undefined) {
//               setSpouseLanguageTest({
//                 languageTestTaken: spouseData.languageTestTaken || "",
//                 languageTestVersion: spouseData.languageTestVersion || "",
//                 dateOfTest: spouseData.dateOfTest
//                   ? formatDate(spouseData.dateOfTest)
//                   : "",
//                 dateOfTestResult: spouseData.dateOfTestResult
//                   ? formatDate(spouseData.dateOfTestResult)
//                   : "",
//                 languageTestCertificateNo:
//                   spouseData.languageTestCertificateNo?.toString() || "",
//                 CELPIPno: spouseData.CELPIPno?.toString() || "",
//                 speaking: spouseData.speaking || "",
//                 reading: spouseData.reading || "",
//                 listening: spouseData.listening || "",
//                 writing: spouseData.writing || "",
//                 takenAnApprovedTestForFrench:
//                   spouseData.takenAnApprovedTestForFrench || "",
//               });
//             }

//             if (spouseData.ECAOrganization !== undefined) {
//               setSpouseECA({
//                 ECAOrganization: spouseData.ECAOrganization || "",
//                 dateECAreportIssued: spouseData.dateECAreportIssued
//                   ? formatDate(spouseData.dateECAreportIssued)
//                   : "",
//                 ECAcertificateNo: spouseData.ECAcertificateNo?.toString() || "",
//                 ECAequivalency: spouseData.ECAequivalency?.toString() || "",
//               });
//             }
//           }

//           toast.success("Education history data loaded successfully!");
//         }
//       } else {
//         toast.error("No data available.");
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed to load education history data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper function to format date from ISO to YYYY-MM-DD
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     fetchApplicantData();
//   }, []);

//   // Handle Primary Education History Changes
//   const handlePrimaryEducationChange = (index, field, value) => {
//     console.log("hello", field, typeof value);
//     const updatedHistory = [...primaryEducationHistory];
//     updatedHistory[index][field] = value;
//     setPrimaryEducationHistory(updatedHistory);
//   };

//   const addPrimaryEducationEntry = () => {
//     setPrimaryEducationHistory([
//       ...primaryEducationHistory,
//       {
//         levelOfEducation: "",
//         studyName: "",
//         fromDate: "",
//         toDate: "",
//         cityOfEducation: "",
//         countryOfEducation: "",
//         nameOfInstitution: "",
//         addressOfInstitution: "",
//         designatedLearningInstituteNo: "",
//         cityOfCampusAttended: "",
//       },
//     ]);
//   };

//   const removePrimaryEducationEntry = (index) => {
//     if (primaryEducationHistory.length > 1) {
//       const updatedHistory = primaryEducationHistory.filter(
//         (_, i) => i !== index,
//       );
//       setPrimaryEducationHistory(updatedHistory);
//     } else {
//       toast.error("At least one education entry is required");
//     }
//   };

//   const handlePrimaryLanguageTestChange = (field, value) => {
//     setPrimaryLanguageTest((prev) => ({ ...prev, [field]: value }));
//   };

//   const handlePrimaryECAChange = (field, value) => {
//     setPrimaryECA((prev) => ({ ...prev, [field]: value }));
//   };

//   // Handle Spouse Education History Changes
//   const handleSpouseEducationChange = (index, field, value) => {
//     const updatedHistory = [...spouseEducationHistory];
//     updatedHistory[index][field] = value;
//     setSpouseEducationHistory(updatedHistory);
//   };

//   const addSpouseEducationEntry = () => {
//     setSpouseEducationHistory([
//       ...spouseEducationHistory,
//       {
//         levelOfEducation: "",
//         studyName: "",
//         fromDate: "",
//         toDate: "",
//         cityOfEducation: "",
//         countryOfEducation: "",
//         nameOfInstitution: "",
//         addressOfInstitution: "",
//         designatedLearningInstituteNo: "",
//         cityOfCampusAttended: "",
//       },
//     ]);
//   };

//   const removeSpouseEducationEntry = (index) => {
//     if (spouseEducationHistory.length > 1) {
//       const updatedHistory = spouseEducationHistory.filter(
//         (_, i) => i !== index,
//       );
//       setSpouseEducationHistory(updatedHistory);
//     } else {
//       toast.error("At least one education entry is required");
//     }
//   };

//   const handleSpouseLanguageTestChange = (field, value) => {
//     setSpouseLanguageTest((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleSpouseECAChange = (field, value) => {
//     setSpouseECA((prev) => ({ ...prev, [field]: value }));
//   };

//   // Generate months and years for dropdowns
//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Prepare primary applicant data
//     console.log("hi", primaryEducationHistory);
//     // return;
//     const primarySubmissionData = {
//       // Education History fields - now an array
//       educationHistory: primaryEducationHistory,

//       // Language Test fields
//       languageTestTaken: primaryLanguageTest.languageTestTaken,
//       languageTestVersion: primaryLanguageTest.languageTestVersion,
//       dateOfTest: primaryLanguageTest.dateOfTest,
//       dateOfTestResult: primaryLanguageTest.dateOfTestResult,
//       languageTestCertificateNo: primaryLanguageTest.languageTestCertificateNo
//         ? parseInt(primaryLanguageTest.languageTestCertificateNo)
//         : "",
//       CELPIPno: primaryLanguageTest.CELPIPno
//         ? parseInt(primaryLanguageTest.CELPIPno)
//         : "",
//       speaking: primaryLanguageTest.speaking,
//       reading: primaryLanguageTest.reading,
//       listening: primaryLanguageTest.listening,
//       writing: primaryLanguageTest.writing,
//       takenAnApprovedTestForFrench:
//         primaryLanguageTest.takenAnApprovedTestForFrench,

//       // ECA fields
//       ECAOrganization: primaryECA.ECAOrganization,
//       dateECAreportIssued: primaryECA.dateECAreportIssued,
//       ECAcertificateNo: primaryECA.ECAcertificateNo
//         ? parseInt(primaryECA.ECAcertificateNo)
//         : "",
//       ECAequivalency: primaryECA.ECAequivalency
//         ? parseInt(primaryECA.ECAequivalency)
//         : "",
//     };

//     console.log("Primary Applicant Education Data:", primarySubmissionData);
//     console.log("Primary Applicant ID:", applicantId);

//     try {
//       setLoading(true);

//       // Update primary applicant data
//       const primaryRes = await HomeServices?.updatePrimaryApplicantData(
//         primarySubmissionData,
//         applicantId,
//       );

//       console.log("Primary applicant response:", primaryRes);

//       if (primaryRes?.status) {
//         toast.success("Primary applicant education data updated successfully!");
//       } else {
//         toast.error(
//           primaryRes?.message || "Failed to update primary applicant data",
//         );
//       }

//       // If spouse exists, update spouse data
//       if (spouseExists && spouseId) {
//         const spouseSubmissionData = {
//           // Education History fields - now an array
//           educationHistory: spouseEducationHistory,

//           // Language Test fields
//           languageTestTaken: spouseLanguageTest.languageTestTaken,
//           languageTestVersion: spouseLanguageTest.languageTestVersion,
//           dateOfTest: spouseLanguageTest.dateOfTest,
//           dateOfTestResult: spouseLanguageTest.dateOfTestResult,
//           languageTestCertificateNo:
//             spouseLanguageTest.languageTestCertificateNo
//               ? parseInt(spouseLanguageTest.languageTestCertificateNo)
//               : "",
//           CELPIPno: spouseLanguageTest.CELPIPno
//             ? parseInt(spouseLanguageTest.CELPIPno)
//             : "",
//           speaking: spouseLanguageTest.speaking,
//           reading: spouseLanguageTest.reading,
//           listening: spouseLanguageTest.listening,
//           writing: spouseLanguageTest.writing,
//           takenAnApprovedTestForFrench:
//             spouseLanguageTest.takenAnApprovedTestForFrench,

//           // ECA fields
//           ECAOrganization: spouseECA.ECAOrganization,
//           dateECAreportIssued: spouseECA.dateECAreportIssued,
//           ECAcertificateNo: spouseECA.ECAcertificateNo
//             ? parseInt(spouseECA.ECAcertificateNo)
//             : "",
//           ECAequivalency: spouseECA.ECAequivalency
//             ? parseInt(spouseECA.ECAequivalency)
//             : "",

//           // Primary applicant ID for spouse update
//           primaryApplicantId: applicantId,
//         };

//         console.log("Spouse Education Data:", spouseSubmissionData);

//         const spouseRes = await HomeServices?.updatePrimaryApplicantSpouseData(
//           spouseSubmissionData,
//           spouseId,
//         );

//         console.log("Spouse response:", spouseRes);

//         if (spouseRes?.status) {
//           toast.success("Spouse education data updated successfully!");
//         } else {
//           toast.error(spouseRes?.message || "Failed to update spouse data");
//         }
//       }

//       // Navigate to next step
//       navigate("/form-fill-up-step5-work-history");
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed to submit education history data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Render education history section
//   const renderEducationHistory = (isPrimary) => {
//     const educationHistory = isPrimary
//       ? primaryEducationHistory
//       : spouseEducationHistory;
//     const handleEducationChange = isPrimary
//       ? handlePrimaryEducationChange
//       : handleSpouseEducationChange;
//     const addEntry = isPrimary
//       ? addPrimaryEducationEntry
//       : addSpouseEducationEntry;
//     const removeEntry = isPrimary
//       ? removePrimaryEducationEntry
//       : removeSpouseEducationEntry;

//     return (
//       <div className="education-history-section">
//         <h2 className="section-title">Education History</h2>
//         {educationHistory.map((edu, index) => (
//           <div key={index} className="education-entry">
//             <div
//               className="entry-header"
//               style={{ display: "flex", justifyContent: "space-between" }}
//             >
//               <h3>Education #{index + 1}</h3>
//               {educationHistory.length > 1 && (
//                 <button
//                   type="button"
//                   className="remove-btn"
//                   onClick={() => removeEntry(index)}
//                 >
//                   Remove
//                 </button>
//               )}
//             </div>
//             <div className="form-columns">
//               <div className="form-column">
//                 <div className="form-group">
//                   <label htmlFor={`levelOfEducation-${isPrimary}-${index}`}>
//                     Level of Education
//                   </label>
//                   <input
//                     type="text"
//                     id={`levelOfEducation-${isPrimary}-${index}`}
//                     value={edu.levelOfEducation}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "levelOfEducation",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="e.g., Bachelor's Degree"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`studyName-${isPrimary}-${index}`}>
//                     Field/Name Of Study
//                   </label>
//                   <input
//                     type="text"
//                     id={`studyName-${isPrimary}-${index}`}
//                     value={edu.studyName}
//                     onChange={(e) =>
//                       handleEducationChange(index, "studyName", e.target.value)
//                     }
//                     placeholder="e.g., Computer Science"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`fromDate-${isPrimary}-${index}`}>
//                     From Date
//                   </label>
//                   <input
//                     type="date"
//                     id={`fromDate-${isPrimary}-${index}`}
//                     value={edu.fromDate}
//                     onChange={(e) =>
//                       handleEducationChange(index, "fromDate", e.target.value)
//                     }
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`toDate-${isPrimary}-${index}`}>
//                     To Date
//                   </label>
//                   <input
//                     type="date"
//                     id={`toDate-${isPrimary}-${index}`}
//                     value={edu.toDate}
//                     onChange={(e) =>
//                       handleEducationChange(index, "toDate", e.target.value)
//                     }
//                   />
//                 </div>
//               </div>

//               <div className="form-column">
//                 <div className="form-group">
//                   <label htmlFor={`cityOfEducation-${isPrimary}-${index}`}>
//                     City of Education
//                   </label>
//                   <input
//                     type="text"
//                     id={`cityOfEducation-${isPrimary}-${index}`}
//                     value={edu.cityOfEducation}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "cityOfEducation",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter city"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`countryOfEducation-${isPrimary}-${index}`}>
//                     Country of Education
//                   </label>
//                   <input
//                     type="text"
//                     id={`countryOfEducation-${isPrimary}-${index}`}
//                     value={edu.countryOfEducation}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "countryOfEducation",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter country"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`nameOfInstitution-${isPrimary}-${index}`}>
//                     Name of School/Institution
//                   </label>
//                   <input
//                     type="text"
//                     id={`nameOfInstitution-${isPrimary}-${index}`}
//                     value={edu.nameOfInstitution}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "nameOfInstitution",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter institution name"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`addressOfInstitution-${isPrimary}-${index}`}>
//                     {/* Address of Institution */}
//                     Address for the Institution attended (with Postal Code)
//                   </label>
//                   <input
//                     type="text"
//                     id={`addressOfInstitution-${isPrimary}-${index}`}
//                     value={edu.addressOfInstitution}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "addressOfInstitution",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter institution address"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label
//                     htmlFor={`designatedLearningInstituteNo-${isPrimary}-${index}`}
//                   >
//                     Designated Learning Institute No (Only for canada)
//                   </label>
//                   <input
//                     type="text"
//                     id={`designatedLearningInstituteNo-${isPrimary}-${index}`}
//                     value={edu.designatedLearningInstituteNo}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "designatedLearningInstituteNo",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter Designated Learning Institute No"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor={`cityOfCampusAttended-${isPrimary}-${index}`}>
//                     City Of Campus you attended
//                   </label>
//                   <input
//                     type="text"
//                     id={`cityOfCampusAttended-${isPrimary}-${index}`}
//                     value={edu.cityOfCampusAttended}
//                     onChange={(e) =>
//                       handleEducationChange(
//                         index,
//                         "cityOfCampusAttended",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter Campus City"
//                   />
//                 </div>
//               </div>
//             </div>
//             {index < educationHistory.length - 1 && (
//               <hr className="entry-divider" />
//             )}
//           </div>
//         ))}
//         <button type="button" className="add-more-btn" onClick={addEntry}>
//           + Add More Education
//         </button>
//       </div>
//     );
//   };

//   // Render form based on active tab
//   const renderForm = () => {
//     const isPrimary = activeTab === "primary";

//     const languageTestData = isPrimary
//       ? primaryLanguageTest
//       : spouseLanguageTest;
//     const ecaData = isPrimary ? primaryECA : spouseECA;

//     const handleLanguageTestChange = isPrimary
//       ? handlePrimaryLanguageTestChange
//       : handleSpouseLanguageTestChange;
//     const handleECAChange = isPrimary
//       ? handlePrimaryECAChange
//       : handleSpouseECAChange;

//     return (
//       <div className="tab-content">
//         {renderEducationHistory(isPrimary)}

//         <h2 className="section-title">Language Test</h2>
//         <div className="form-columns">
//           <div className="form-column">
//             <div className="form-group">
//               <label htmlFor="languageTestTaken">Language Test Taken</label>
//               <select
//                 id="languageTestTaken"
//                 value={languageTestData.languageTestTaken}
//                 onChange={(e) =>
//                   handleLanguageTestChange("languageTestTaken", e.target.value)
//                 }
//               >
//                 <option value="">Select option</option>
//                 <option value="Yes">Yes</option>
//                 <option value="No">No</option>
//               </select>
//             </div>

//             {languageTestData.languageTestTaken === "Yes" && (
//               <>
//                 <div className="form-group">
//                   <label htmlFor="languageTestVersion">
//                     Language Test Version
//                   </label>
//                   <input
//                     type="text"
//                     id="languageTestVersion"
//                     value={languageTestData.languageTestVersion}
//                     onChange={(e) =>
//                       handleLanguageTestChange(
//                         "languageTestVersion",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="e.g., IELTS Academic 2021"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="dateOfTest">Date of Test</label>
//                   <input
//                     type="date"
//                     id="dateOfTest"
//                     value={languageTestData.dateOfTest}
//                     onChange={(e) =>
//                       handleLanguageTestChange("dateOfTest", e.target.value)
//                     }
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="dateOfTestResult">Date of Test Result</label>
//                   <input
//                     type="date"
//                     id="dateOfTestResult"
//                     value={languageTestData.dateOfTestResult}
//                     onChange={(e) =>
//                       handleLanguageTestChange(
//                         "dateOfTestResult",
//                         e.target.value,
//                       )
//                     }
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="languageTestCertificateNo">
//                     Language Test Certificate Number
//                   </label>
//                   <input
//                     type="number"
//                     id="languageTestCertificateNo"
//                     value={languageTestData.languageTestCertificateNo}
//                     onChange={(e) =>
//                       handleLanguageTestChange(
//                         "languageTestCertificateNo",
//                         e.target.value,
//                       )
//                     }
//                     placeholder="Enter certificate number"
//                   />
//                 </div>
//               </>
//             )}
//           </div>

//           <div className="form-column">
//             {languageTestData.languageTestTaken === "Yes" && (
//               <>
//                 <div className="form-group">
//                   <label htmlFor="CELPIPno">CELPIP PIN Number</label>
//                   <input
//                     type="number"
//                     id="CELPIPno"
//                     value={languageTestData.CELPIPno}
//                     onChange={(e) =>
//                       handleLanguageTestChange("CELPIPno", e.target.value)
//                     }
//                     placeholder="Enter CELPIP PIN if applicable"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="speaking">Speaking</label>
//                   <select
//                     id="speaking"
//                     value={languageTestData.speaking}
//                     onChange={(e) =>
//                       handleLanguageTestChange("speaking", e.target.value)
//                     }
//                   >
//                     <option value="">Select option</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="reading">Reading</label>
//                   <select
//                     id="reading"
//                     value={languageTestData.reading}
//                     onChange={(e) =>
//                       handleLanguageTestChange("reading", e.target.value)
//                     }
//                   >
//                     <option value="">Select option</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="listening">Listening</label>
//                   <select
//                     id="listening"
//                     value={languageTestData.listening}
//                     onChange={(e) =>
//                       handleLanguageTestChange("listening", e.target.value)
//                     }
//                   >
//                     <option value="">Select option</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="writing">Writing</label>
//                   <select
//                     id="writing"
//                     value={languageTestData.writing}
//                     onChange={(e) =>
//                       handleLanguageTestChange("writing", e.target.value)
//                     }
//                   >
//                     <option value="">Select option</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="takenAnApprovedTestForFrench">
//                     Approved Test for French?
//                   </label>
//                   <select
//                     id="takenAnApprovedTestForFrench"
//                     value={languageTestData.takenAnApprovedTestForFrench}
//                     onChange={(e) =>
//                       handleLanguageTestChange(
//                         "takenAnApprovedTestForFrench",
//                         e.target.value,
//                       )
//                     }
//                   >
//                     <option value="">Select option</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         <h2 className="section-title">
//           Educational Credential Assessment (ECA)
//         </h2>
//         <div className="form-columns">
//           <div className="form-column">
//             <div className="form-group">
//               <label htmlFor="ECAOrganization">Organization</label>
//               <input
//                 type="text"
//                 id="ECAOrganization"
//                 value={ecaData.ECAOrganization}
//                 onChange={(e) =>
//                   handleECAChange("ECAOrganization", e.target.value)
//                 }
//                 placeholder="e.g., WES, ICAS"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="dateECAreportIssued">
//                 Date ECA report issued
//               </label>
//               <input
//                 type="date"
//                 id="dateECAreportIssued"
//                 value={ecaData.dateECAreportIssued}
//                 onChange={(e) =>
//                   handleECAChange("dateECAreportIssued", e.target.value)
//                 }
//               />
//             </div>
//           </div>

//           <div className="form-column">
//             <div className="form-group">
//               <label htmlFor="ECAcertificateNo">ECA Certificate Number</label>
//               <input
//                 type="number"
//                 id="ECAcertificateNo"
//                 value={ecaData.ECAcertificateNo}
//                 onChange={(e) =>
//                   handleECAChange("ECAcertificateNo", e.target.value)
//                 }
//                 placeholder="Enter certificate number"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="ECAequivalency">ECA Equivalency</label>
//               <input
//                 type="number"
//                 id="ECAequivalency"
//                 value={ecaData.ECAequivalency}
//                 onChange={(e) =>
//                   handleECAChange("ECAequivalency", e.target.value)
//                 }
//                 placeholder="Enter equivalency code"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="education-container">
//       <div className="form-header">
//         <h1>Education History </h1>
//         <p>
//           Please provide education, language test, and ECA information for the
//           primary applicant and spouse.
//         </p>
//       </div>

//       {loading && (
//         <div className="loading-indicator">
//           <p>Loading education history data...</p>
//         </div>
//       )}

//       <div className="tab-navigation">
//         <button
//           className={`tab-btn ${activeTab === "primary" ? "active" : ""}`}
//           onClick={() => setActiveTab("primary")}
//         >
//           Primary Applicant
//         </button>
//         {spouseExists && (
//           <button
//             className={`tab-btn ${activeTab === "spouse" ? "active" : ""}`}
//             onClick={() => setActiveTab("spouse")}
//           >
//             Spouse
//           </button>
//         )}
//       </div>

//       <form onSubmit={handleSubmit}>
//         {renderForm()}

//         <div className="form-footer" style={{ display: "flex", gap: "20px" }}>
//           <button
//             onClick={() => {
//               navigate(-1);
//             }}
//             type="button"
//             className="submit-btn"
//             disabled={loading}
//           >
//             Back
//           </button>
//           <button type="submit" className="submit-btn" disabled={loading}>
//             {loading ? "Saving..." : "Save and Next"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EducationHistory;

import React, { useState, useEffect } from "react";
import "./EducationHistory.css";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const EducationHistory = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("primary");
  const [applicantId, setApplicantId] = useState("");
  const [spouseId, setSpouseId] = useState("");
  const [spouseExists, setSpouseExists] = useState(false);
  const navigate = useNavigate();

  // Primary Applicant Education History Array
  const [primaryEducationHistory, setPrimaryEducationHistory] = useState([
    {
      levelOfEducation: "",
      studyName: "",
      fromDate: "",
      toDate: "",
      cityOfEducation: "",
      countryOfEducation: "",
      nameOfInstitution: "",
      addressOfInstitution: "",
      designatedLearningInstituteNo: "",
      cityOfCampusAttended: "",
    },
  ]);

  const [primaryLanguageTest, setPrimaryLanguageTest] = useState({
    languageTestTaken: "",
    languageTestVersion: "",
    dateOfTest: "",
    dateOfTestResult: "",
    languageTestCertificateNo: "",
    // New fields
    typeOfTest: "",
    IELTScertificateNo: "",
    CELPIPregNo: "",
    CELPIPpinNo: "",
    PTEreportCode: "",
    PTEtestTakerId: "",
    PTEregId: "",
    // Existing fields
    speaking: "",
    reading: "",
    listening: "",
    writing: "",
    takenAnApprovedTestForFrench: "",
  });

  const [primaryECA, setPrimaryECA] = useState({
    ECAOrganization: "",
    dateECAreportIssued: "",
    ECAcertificateNo: "",
    ECAequivalency: "",
    ECA2equivalency: "",
  });

  // Spouse Education History Array
  const [spouseEducationHistory, setSpouseEducationHistory] = useState([
    {
      levelOfEducation: "",
      studyName: "",
      fromDate: "",
      toDate: "",
      cityOfEducation: "",
      countryOfEducation: "",
      nameOfInstitution: "",
      addressOfInstitution: "",
      designatedLearningInstituteNo: "",
      cityOfCampusAttended: "",
    },
  ]);

  const [spouseLanguageTest, setSpouseLanguageTest] = useState({
    languageTestTaken: "",
    languageTestVersion: "",
    dateOfTest: "",
    dateOfTestResult: "",
    languageTestCertificateNo: "",
    // New fields
    typeOfTest: "",
    IELTScertificateNo: "",
    CELPIPregNo: "",
    CELPIPpinNo: "",
    PTEreportCode: "",
    PTEtestTakerId: "",
    PTEregId: "",
    // Existing fields
    speaking: "",
    reading: "",
    listening: "",
    writing: "",
    takenAnApprovedTestForFrench: "",
  });

  const [spouseECA, setSpouseECA] = useState({
    ECAOrganization: "",
    dateECAreportIssued: "",
    ECAcertificateNo: "",
    ECAequivalency: "",
    ECA2equivalency: "",
  });

  const fetchApplicantData = async () => {
    try {
      setLoading(true);
      const res = await HomeServices.getPrimariApplicantData();
      console.log("Education history data response:", res);

      if (res?.status && res?.data && res.data.length > 0) {
        const primaryData = res.data[0]?.PrimaryApplicantData;

        if (primaryData) {
          // Set applicant ID
          setApplicantId(primaryData._id);

          // Check if spouse exists
          if (primaryData.PrimaryApplicantSpouseData?._id) {
            setSpouseExists(true);
            setSpouseId(primaryData.PrimaryApplicantSpouseData._id);
          }

          // Load primary applicant education history
          if (
            primaryData.educationHistory &&
            primaryData.educationHistory.length > 0
          ) {
            setPrimaryEducationHistory(
              primaryData.educationHistory.map((edu) => ({
                levelOfEducation: edu.levelOfEducation || "",
                studyName: edu.studyName || "",
                fromDate: edu.fromDate ? formatDate(edu.fromDate) : "",
                toDate: edu.toDate ? formatDate(edu.toDate) : "",
                cityOfEducation: edu.cityOfEducation || "",
                countryOfEducation: edu.countryOfEducation || "",
                nameOfInstitution: edu.nameOfInstitution || "",
                addressOfInstitution: edu.addressOfInstitution || "",
                designatedLearningInstituteNo:
                  edu.designatedLearningInstituteNo?.toString() || "",
                cityOfCampusAttended: edu.cityOfCampusAttended || "",
              })),
            );
          }

          // Load primary applicant language test data
          if (primaryData.languageTestTaken !== undefined) {
            setPrimaryLanguageTest({
              languageTestTaken: primaryData.languageTestTaken || "",
              languageTestVersion: primaryData.languageTestVersion || "",
              dateOfTest: primaryData.dateOfTest
                ? formatDate(primaryData.dateOfTest)
                : "",
              dateOfTestResult: primaryData.dateOfTestResult
                ? formatDate(primaryData.dateOfTestResult)
                : "",
              languageTestCertificateNo:
                primaryData.languageTestCertificateNo?.toString() || "",
              // New fields
              typeOfTest: primaryData.typeOfTest || "",
              IELTScertificateNo:
                primaryData.IELTScertificateNo?.toString() || "",
              CELPIPregNo: primaryData.CELPIPregNo?.toString() || "",
              CELPIPpinNo: primaryData.CELPIPpinNo?.toString() || "",
              PTEreportCode: primaryData.PTEreportCode?.toString() || "",
              PTEtestTakerId: primaryData.PTEtestTakerId?.toString() || "",
              PTEregId: primaryData.PTEregId?.toString() || "",
              // Existing fields
              speaking: primaryData.speaking || "",
              reading: primaryData.reading || "",
              listening: primaryData.listening || "",
              writing: primaryData.writing || "",
              takenAnApprovedTestForFrench:
                primaryData.takenAnApprovedTestForFrench || "",
            });
          }

          // Load primary applicant ECA data
          if (primaryData.ECAOrganization !== undefined) {
            setPrimaryECA({
              ECAOrganization: primaryData.ECAOrganization || "",
              dateECAreportIssued: primaryData.dateECAreportIssued
                ? formatDate(primaryData.dateECAreportIssued)
                : "",
              ECAcertificateNo: primaryData.ECAcertificateNo?.toString() || "",
              ECAequivalency: primaryData.ECAequivalency?.toString() || "",
              ECA2equivalency: primaryData.ECA2equivalency?.toString() || "",
            });
          }

          // Load spouse education history if exists
          const spouseData = primaryData.PrimaryApplicantSpouseData;
          if (spouseData) {
            if (
              spouseData.educationHistory &&
              spouseData.educationHistory.length > 0
            ) {
              setSpouseEducationHistory(
                spouseData.educationHistory.map((edu) => ({
                  levelOfEducation: edu.levelOfEducation || "",
                  studyName: edu.studyName || "",
                  fromDate: edu.fromDate ? formatDate(edu.fromDate) : "",
                  toDate: edu.toDate ? formatDate(edu.toDate) : "",
                  cityOfEducation: edu.cityOfEducation || "",
                  countryOfEducation: edu.countryOfEducation || "",
                  nameOfInstitution: edu.nameOfInstitution || "",
                  addressOfInstitution: edu.addressOfInstitution || "",
                  designatedLearningInstituteNo:
                    edu.designatedLearningInstituteNo?.toString() || "",
                  cityOfCampusAttended: edu.cityOfCampusAttended || "",
                })),
              );
            }

            if (spouseData.languageTestTaken !== undefined) {
              setSpouseLanguageTest({
                languageTestTaken: spouseData.languageTestTaken || "",
                languageTestVersion: spouseData.languageTestVersion || "",
                dateOfTest: spouseData.dateOfTest
                  ? formatDate(spouseData.dateOfTest)
                  : "",
                dateOfTestResult: spouseData.dateOfTestResult
                  ? formatDate(spouseData.dateOfTestResult)
                  : "",
                languageTestCertificateNo:
                  spouseData.languageTestCertificateNo?.toString() || "",
                // New fields
                typeOfTest: spouseData.typeOfTest || "",
                IELTScertificateNo:
                  spouseData.IELTScertificateNo?.toString() || "",
                CELPIPregNo: spouseData.CELPIPregNo?.toString() || "",
                CELPIPpinNo: spouseData.CELPIPpinNo?.toString() || "",
                PTEreportCode: spouseData.PTEreportCode?.toString() || "",
                PTEtestTakerId: spouseData.PTEtestTakerId?.toString() || "",
                PTEregId: spouseData.PTEregId?.toString() || "",
                // Existing fields
                speaking: spouseData.speaking || "",
                reading: spouseData.reading || "",
                listening: spouseData.listening || "",
                writing: spouseData.writing || "",
                takenAnApprovedTestForFrench:
                  spouseData.takenAnApprovedTestForFrench || "",
              });
            }

            if (spouseData.ECAOrganization !== undefined) {
              setSpouseECA({
                ECAOrganization: spouseData.ECAOrganization || "",
                dateECAreportIssued: spouseData.dateECAreportIssued
                  ? formatDate(spouseData.dateECAreportIssued)
                  : "",
                ECAcertificateNo: spouseData.ECAcertificateNo?.toString() || "",
                ECAequivalency: spouseData.ECAequivalency?.toString() || "",
                ECA2equivalency: spouseData.ECA2equivalency?.toString() || "",
              });
            }
          }

          toast.success("Education history data loaded successfully!");
        }
      } else {
        toast.error("No data available.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load education history data");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to format date from ISO to YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    fetchApplicantData();
  }, []);

  // Handle Primary Education History Changes
  const handlePrimaryEducationChange = (index, field, value) => {
    const updatedHistory = [...primaryEducationHistory];
    updatedHistory[index][field] = value;
    setPrimaryEducationHistory(updatedHistory);
  };

  const addPrimaryEducationEntry = () => {
    setPrimaryEducationHistory([
      ...primaryEducationHistory,
      {
        levelOfEducation: "",
        studyName: "",
        fromDate: "",
        toDate: "",
        cityOfEducation: "",
        countryOfEducation: "",
        nameOfInstitution: "",
        addressOfInstitution: "",
        designatedLearningInstituteNo: "",
        cityOfCampusAttended: "",
      },
    ]);
  };

  const removePrimaryEducationEntry = (index) => {
    if (primaryEducationHistory.length > 1) {
      const updatedHistory = primaryEducationHistory.filter(
        (_, i) => i !== index,
      );
      setPrimaryEducationHistory(updatedHistory);
    } else {
      toast.error("At least one education entry is required");
    }
  };

  const handlePrimaryLanguageTestChange = (field, value) => {
    setPrimaryLanguageTest((prev) => ({ ...prev, [field]: value }));
  };

  const handlePrimaryECAChange = (field, value) => {
    setPrimaryECA((prev) => ({ ...prev, [field]: value }));
  };

  // Handle Spouse Education History Changes
  const handleSpouseEducationChange = (index, field, value) => {
    const updatedHistory = [...spouseEducationHistory];
    updatedHistory[index][field] = value;
    setSpouseEducationHistory(updatedHistory);
  };

  const addSpouseEducationEntry = () => {
    setSpouseEducationHistory([
      ...spouseEducationHistory,
      {
        levelOfEducation: "",
        studyName: "",
        fromDate: "",
        toDate: "",
        cityOfEducation: "",
        countryOfEducation: "",
        nameOfInstitution: "",
        addressOfInstitution: "",
        designatedLearningInstituteNo: "",
        cityOfCampusAttended: "",
      },
    ]);
  };

  const removeSpouseEducationEntry = (index) => {
    if (spouseEducationHistory.length > 1) {
      const updatedHistory = spouseEducationHistory.filter(
        (_, i) => i !== index,
      );
      setSpouseEducationHistory(updatedHistory);
    } else {
      toast.error("At least one education entry is required");
    }
  };

  const handleSpouseLanguageTestChange = (field, value) => {
    setSpouseLanguageTest((prev) => ({ ...prev, [field]: value }));
  };

  const handleSpouseECAChange = (field, value) => {
    setSpouseECA((prev) => ({ ...prev, [field]: value }));
  };

  // Render language test fields based on test type
  const renderTestTypeFields = (languageTestData, handleChange, isPrimary) => {
    const prefix = isPrimary ? "primary" : "spouse";

    switch (languageTestData.typeOfTest) {
      case "IELTS":
        return (
          <div className="form-group">
            <label htmlFor={`${prefix}-IELTScertificateNo`}>
              IELTS Certificate Number
            </label>
            <input
              type="text"
              id={`${prefix}-IELTScertificateNo`}
              value={languageTestData.IELTScertificateNo || ""}
              onChange={(e) =>
                handleChange("IELTScertificateNo", e.target.value)
              }
              placeholder="Enter IELTS certificate number"
            />
          </div>
        );

      case "CELPIP":
        return (
          <>
            <div className="form-group">
              <label htmlFor={`${prefix}-CELPIPregNo`}>
                CELPIP Registration Number
              </label>
              <input
                type="text"
                id={`${prefix}-CELPIPregNo`}
                value={languageTestData.CELPIPregNo || ""}
                onChange={(e) => handleChange("CELPIPregNo", e.target.value)}
                placeholder="Enter CELPIP registration number"
              />
            </div>
            <div className="form-group">
              <label htmlFor={`${prefix}-CELPIPpinNo`}>CELPIP PIN Number</label>
              <input
                type="text"
                id={`${prefix}-CELPIPpinNo`}
                value={languageTestData.CELPIPpinNo || ""}
                onChange={(e) => handleChange("CELPIPpinNo", e.target.value)}
                placeholder="Enter CELPIP PIN number"
              />
            </div>
          </>
        );

      case "PTE":
        return (
          <>
            <div className="form-group">
              <label htmlFor={`${prefix}-PTEreportCode`}>PTE Report Code</label>
              <input
                type="text"
                id={`${prefix}-PTEreportCode`}
                value={languageTestData.PTEreportCode || ""}
                onChange={(e) => handleChange("PTEreportCode", e.target.value)}
                placeholder="Enter PTE report code"
              />
            </div>
            <div className="form-group">
              <label htmlFor={`${prefix}-PTEtestTakerId`}>
                PTE Test Taker ID
              </label>
              <input
                type="text"
                id={`${prefix}-PTEtestTakerId`}
                value={languageTestData.PTEtestTakerId || ""}
                onChange={(e) => handleChange("PTEtestTakerId", e.target.value)}
                placeholder="Enter PTE test taker ID"
              />
            </div>
            <div className="form-group">
              <label htmlFor={`${prefix}-PTEregId`}>PTE Registration ID</label>
              <input
                type="text"
                id={`${prefix}-PTEregId`}
                value={languageTestData.PTEregId || ""}
                onChange={(e) => handleChange("PTEregId", e.target.value)}
                placeholder="Enter PTE registration ID"
              />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare primary applicant data
    const primarySubmissionData = {
      // Education History fields
      educationHistory: primaryEducationHistory.map((edu) => ({
        levelOfEducation: edu.levelOfEducation || "",
        studyName: edu.studyName || "",
        fromDate: edu.fromDate || null,
        toDate: edu.toDate || null,
        cityOfEducation: edu.cityOfEducation || "",
        countryOfEducation: edu.countryOfEducation || "",
        nameOfInstitution: edu.nameOfInstitution || "",
        addressOfInstitution: edu.addressOfInstitution || "",
        designatedLearningInstituteNo:
          edu.designatedLearningInstituteNo?.toString() || "",
        cityOfCampusAttended: edu.cityOfCampusAttended || "",
      })),

      // Language Test fields
      languageTestTaken: primaryLanguageTest.languageTestTaken,
      languageTestVersion: primaryLanguageTest.languageTestVersion || "",
      dateOfTest: primaryLanguageTest.dateOfTest || null,
      dateOfTestResult: primaryLanguageTest.dateOfTestResult || null,
      languageTestCertificateNo:
        primaryLanguageTest.languageTestCertificateNo?.toString() || "",

      // New test type fields
      typeOfTest: primaryLanguageTest.typeOfTest || "",
      IELTScertificateNo:
        primaryLanguageTest.IELTScertificateNo?.toString() || "",
      CELPIPregNo: primaryLanguageTest.CELPIPregNo?.toString() || "",
      CELPIPpinNo: primaryLanguageTest.CELPIPpinNo?.toString() || "",
      PTEreportCode: primaryLanguageTest.PTEreportCode?.toString() || "",
      PTEtestTakerId: primaryLanguageTest.PTEtestTakerId?.toString() || "",
      PTEregId: primaryLanguageTest.PTEregId?.toString() || "",

      // Existing fields
      speaking: primaryLanguageTest.speaking || "",
      reading: primaryLanguageTest.reading || "",
      listening: primaryLanguageTest.listening || "",
      writing: primaryLanguageTest.writing || "",
      takenAnApprovedTestForFrench:
        primaryLanguageTest.takenAnApprovedTestForFrench || "",

      // ECA fields
      ECAOrganization: primaryECA.ECAOrganization || "",
      dateECAreportIssued: primaryECA.dateECAreportIssued || null,
      ECAcertificateNo: primaryECA.ECAcertificateNo?.toString() || "",
      ECAequivalency: primaryECA.ECAequivalency?.toString() || "",
      ECA2equivalency: primaryECA.ECA2equivalency?.toString() || "",
    };

    console.log("Primary Applicant Education Data:", primarySubmissionData);

    try {
      setLoading(true);

      // Update primary applicant data
      const primaryRes = await HomeServices?.updatePrimaryApplicantData(
        primarySubmissionData,
        applicantId,
      );

      console.log("Primary applicant response:", primaryRes);

      if (primaryRes?.status) {
        toast.success("Primary applicant education data updated successfully!");
      } else {
        toast.error(
          primaryRes?.message || "Failed to update primary applicant data",
        );
      }

      // If spouse exists, update spouse data
      if (spouseExists && spouseId) {
        const spouseSubmissionData = {
          // Education History fields
          educationHistory: spouseEducationHistory.map((edu) => ({
            levelOfEducation: edu.levelOfEducation || "",
            studyName: edu.studyName || "",
            fromDate: edu.fromDate || null,
            toDate: edu.toDate || null,
            cityOfEducation: edu.cityOfEducation || "",
            countryOfEducation: edu.countryOfEducation || "",
            nameOfInstitution: edu.nameOfInstitution || "",
            addressOfInstitution: edu.addressOfInstitution || "",
            designatedLearningInstituteNo:
              edu.designatedLearningInstituteNo?.toString() || "",
            cityOfCampusAttended: edu.cityOfCampusAttended || "",
          })),

          // Language Test fields
          languageTestTaken: spouseLanguageTest.languageTestTaken,
          languageTestVersion: spouseLanguageTest.languageTestVersion || "",
          dateOfTest: spouseLanguageTest.dateOfTest || null,
          dateOfTestResult: spouseLanguageTest.dateOfTestResult || null,
          languageTestCertificateNo:
            spouseLanguageTest.languageTestCertificateNo?.toString() || "",

          // New test type fields
          typeOfTest: spouseLanguageTest.typeOfTest || "",
          IELTScertificateNo:
            spouseLanguageTest.IELTScertificateNo?.toString() || "",
          CELPIPregNo: spouseLanguageTest.CELPIPregNo?.toString() || "",
          CELPIPpinNo: spouseLanguageTest.CELPIPpinNo?.toString() || "",
          PTEreportCode: spouseLanguageTest.PTEreportCode?.toString() || "",
          PTEtestTakerId: spouseLanguageTest.PTEtestTakerId?.toString() || "",
          PTEregId: spouseLanguageTest.PTEregId?.toString() || "",

          // Existing fields
          speaking: spouseLanguageTest.speaking || "",
          reading: spouseLanguageTest.reading || "",
          listening: spouseLanguageTest.listening || "",
          writing: spouseLanguageTest.writing || "",
          takenAnApprovedTestForFrench:
            spouseLanguageTest.takenAnApprovedTestForFrench || "",

          // ECA fields
          ECAOrganization: spouseECA.ECAOrganization || "",
          dateECAreportIssued: spouseECA.dateECAreportIssued || null,
          ECAcertificateNo: spouseECA.ECAcertificateNo?.toString() || "",
          ECAequivalency: spouseECA.ECAequivalency?.toString() || "",
          ECA2equivalency: spouseECA.ECA2equivalency?.toString() || "",

          // Primary applicant ID for spouse update
          primaryApplicantId: applicantId,
        };

        console.log("Spouse Education Data:", spouseSubmissionData);

        const spouseRes = await HomeServices?.updatePrimaryApplicantSpouseData(
          spouseSubmissionData,
          spouseId,
        );

        console.log("Spouse response:", spouseRes);

        if (spouseRes?.status) {
          toast.success("Spouse education data updated successfully!");
        } else {
          toast.error(spouseRes?.message || "Failed to update spouse data");
        }
      }

      // Navigate to next step
      navigate("/form-fill-up-step5-work-history");
    } catch (error) {
      console.log(error);
      toast.error("Failed to submit education history data");
    } finally {
      setLoading(false);
    }
  };

  // Render education history section
  const renderEducationHistory = (isPrimary) => {
    const educationHistory = isPrimary
      ? primaryEducationHistory
      : spouseEducationHistory;
    const handleEducationChange = isPrimary
      ? handlePrimaryEducationChange
      : handleSpouseEducationChange;
    const addEntry = isPrimary
      ? addPrimaryEducationEntry
      : addSpouseEducationEntry;
    const removeEntry = isPrimary
      ? removePrimaryEducationEntry
      : removeSpouseEducationEntry;

    return (
      <div className="education-history-section">
        <h2 className="section-title">Education History</h2>
        {educationHistory.map((edu, index) => (
          <div key={index} className="education-entry">
            <div
              className="entry-header"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <h3>Education #{index + 1}</h3>
              {educationHistory.length > 1 && (
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => removeEntry(index)}
                >
                  Remove
                </button>
              )}
            </div>
            <div className="form-columns">
              <div className="form-column">
                <div className="form-group">
                  <label htmlFor={`levelOfEducation-${isPrimary}-${index}`}>
                    Level of Education
                  </label>
                  <input
                    type="text"
                    id={`levelOfEducation-${isPrimary}-${index}`}
                    value={edu.levelOfEducation}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "levelOfEducation",
                        e.target.value,
                      )
                    }
                    placeholder="e.g., Bachelor's Degree"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`studyName-${isPrimary}-${index}`}>
                    Field/Name Of Study
                  </label>
                  <input
                    type="text"
                    id={`studyName-${isPrimary}-${index}`}
                    value={edu.studyName}
                    onChange={(e) =>
                      handleEducationChange(index, "studyName", e.target.value)
                    }
                    placeholder="e.g., Computer Science"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`fromDate-${isPrimary}-${index}`}>
                    From Date
                  </label>
                  <input
                    type="date"
                    id={`fromDate-${isPrimary}-${index}`}
                    value={edu.fromDate}
                    onChange={(e) =>
                      handleEducationChange(index, "fromDate", e.target.value)
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`toDate-${isPrimary}-${index}`}>
                    To Date
                  </label>
                  <input
                    type="date"
                    id={`toDate-${isPrimary}-${index}`}
                    value={edu.toDate}
                    onChange={(e) =>
                      handleEducationChange(index, "toDate", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="form-column">
                <div className="form-group">
                  <label htmlFor={`cityOfEducation-${isPrimary}-${index}`}>
                    City of Education
                  </label>
                  <input
                    type="text"
                    id={`cityOfEducation-${isPrimary}-${index}`}
                    value={edu.cityOfEducation}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "cityOfEducation",
                        e.target.value,
                      )
                    }
                    placeholder="Enter city"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`countryOfEducation-${isPrimary}-${index}`}>
                    Country of Education
                  </label>
                  <input
                    type="text"
                    id={`countryOfEducation-${isPrimary}-${index}`}
                    value={edu.countryOfEducation}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "countryOfEducation",
                        e.target.value,
                      )
                    }
                    placeholder="Enter country"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`nameOfInstitution-${isPrimary}-${index}`}>
                    Name of School/Institution
                  </label>
                  <input
                    type="text"
                    id={`nameOfInstitution-${isPrimary}-${index}`}
                    value={edu.nameOfInstitution}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "nameOfInstitution",
                        e.target.value,
                      )
                    }
                    placeholder="Enter institution name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`addressOfInstitution-${isPrimary}-${index}`}>
                    Address for the Institution attended (with Postal Code)
                  </label>
                  <input
                    type="text"
                    id={`addressOfInstitution-${isPrimary}-${index}`}
                    value={edu.addressOfInstitution}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "addressOfInstitution",
                        e.target.value,
                      )
                    }
                    placeholder="Enter institution address"
                  />
                </div>

                <div className="form-group">
                  <label
                    htmlFor={`designatedLearningInstituteNo-${isPrimary}-${index}`}
                  >
                    Designated Learning Institute No (Only for canada)
                  </label>
                  <input
                    type="text"
                    id={`designatedLearningInstituteNo-${isPrimary}-${index}`}
                    value={edu.designatedLearningInstituteNo}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "designatedLearningInstituteNo",
                        e.target.value,
                      )
                    }
                    placeholder="Enter Designated Learning Institute No"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`cityOfCampusAttended-${isPrimary}-${index}`}>
                    City Of Campus you attended
                  </label>
                  <input
                    type="text"
                    id={`cityOfCampusAttended-${isPrimary}-${index}`}
                    value={edu.cityOfCampusAttended}
                    onChange={(e) =>
                      handleEducationChange(
                        index,
                        "cityOfCampusAttended",
                        e.target.value,
                      )
                    }
                    placeholder="Enter Campus City"
                  />
                </div>
              </div>
            </div>
            {index < educationHistory.length - 1 && (
              <hr className="entry-divider" />
            )}
          </div>
        ))}
        <button type="button" className="add-more-btn" onClick={addEntry}>
          + Add More Education
        </button>
      </div>
    );
  };

  // Render form based on active tab
  const renderForm = () => {
    const isPrimary = activeTab === "primary";

    const languageTestData = isPrimary
      ? primaryLanguageTest
      : spouseLanguageTest;
    const ecaData = isPrimary ? primaryECA : spouseECA;

    const handleLanguageTestChange = isPrimary
      ? handlePrimaryLanguageTestChange
      : handleSpouseLanguageTestChange;
    const handleECAChange = isPrimary
      ? handlePrimaryECAChange
      : handleSpouseECAChange;

    return (
      <div className="tab-content">
        {renderEducationHistory(isPrimary)}

        <h2 className="section-title">Language Test</h2>
        <div className="form-columns">
          <div className="form-column">
            <div className="form-group">
              <label htmlFor="languageTestTaken">Language Test Taken</label>
              <select
                id="languageTestTaken"
                value={languageTestData.languageTestTaken}
                onChange={(e) =>
                  handleLanguageTestChange("languageTestTaken", e.target.value)
                }
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {languageTestData.languageTestTaken === "Yes" && (
              <>
                <div className="form-group">
                  <label htmlFor="languageTestVersion">
                    Language Test Version
                  </label>
                  <input
                    type="text"
                    id="languageTestVersion"
                    value={languageTestData.languageTestVersion}
                    onChange={(e) =>
                      handleLanguageTestChange(
                        "languageTestVersion",
                        e.target.value,
                      )
                    }
                    placeholder="e.g., IELTS Academic 2021"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="typeOfTest">Type of Test</label>
                  <select
                    id="typeOfTest"
                    value={languageTestData.typeOfTest}
                    onChange={(e) =>
                      handleLanguageTestChange("typeOfTest", e.target.value)
                    }
                  >
                    <option value="">Select test type</option>
                    <option value="IELTS">IELTS</option>
                    <option value="CELPIP">CELPIP</option>
                    <option value="PTE">PTE</option>
                  </select>
                </div>

                {renderTestTypeFields(
                  languageTestData,
                  handleLanguageTestChange,
                  isPrimary,
                )}

                <div className="form-group">
                  <label htmlFor="dateOfTest">Date of Test</label>
                  <input
                    type="date"
                    id="dateOfTest"
                    value={languageTestData.dateOfTest}
                    onChange={(e) =>
                      handleLanguageTestChange("dateOfTest", e.target.value)
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="dateOfTestResult">Date of Test Result</label>
                  <input
                    type="date"
                    id="dateOfTestResult"
                    value={languageTestData.dateOfTestResult}
                    onChange={(e) =>
                      handleLanguageTestChange(
                        "dateOfTestResult",
                        e.target.value,
                      )
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="languageTestCertificateNo">
                    Language Test Certificate Number
                  </label>
                  <input
                    type="text"
                    id="languageTestCertificateNo"
                    value={languageTestData.languageTestCertificateNo}
                    onChange={(e) =>
                      handleLanguageTestChange(
                        "languageTestCertificateNo",
                        e.target.value,
                      )
                    }
                    placeholder="Enter certificate number"
                  />
                </div>
              </>
            )}
          </div>

          <div className="form-column">
            {languageTestData.languageTestTaken === "Yes" && (
              <>
                <div className="form-group">
                  <label htmlFor="speaking">Speaking</label>
                  <select
                    id="speaking"
                    value={languageTestData.speaking}
                    onChange={(e) =>
                      handleLanguageTestChange("speaking", e.target.value)
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="reading">Reading</label>
                  <select
                    id="reading"
                    value={languageTestData.reading}
                    onChange={(e) =>
                      handleLanguageTestChange("reading", e.target.value)
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="listening">Listening</label>
                  <select
                    id="listening"
                    value={languageTestData.listening}
                    onChange={(e) =>
                      handleLanguageTestChange("listening", e.target.value)
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="writing">Writing</label>
                  <select
                    id="writing"
                    value={languageTestData.writing}
                    onChange={(e) =>
                      handleLanguageTestChange("writing", e.target.value)
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="takenAnApprovedTestForFrench">
                    Approved Test for French?
                  </label>
                  <select
                    id="takenAnApprovedTestForFrench"
                    value={languageTestData.takenAnApprovedTestForFrench}
                    onChange={(e) =>
                      handleLanguageTestChange(
                        "takenAnApprovedTestForFrench",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </>
            )}
          </div>
        </div>

        <h2 className="section-title">
          Educational Credential Assessment (ECA)
        </h2>
        <div className="form-columns">
          <div className="form-column">
            <div className="form-group">
              <label htmlFor="ECAOrganization">Organization</label>
              <input
                type="text"
                id="ECAOrganization"
                value={ecaData.ECAOrganization}
                onChange={(e) =>
                  handleECAChange("ECAOrganization", e.target.value)
                }
                placeholder="e.g., WES, ICAS"
              />
            </div>

            <div className="form-group">
              <label htmlFor="dateECAreportIssued">
                Date ECA report issued
              </label>
              <input
                type="date"
                id="dateECAreportIssued"
                value={ecaData.dateECAreportIssued}
                onChange={(e) =>
                  handleECAChange("dateECAreportIssued", e.target.value)
                }
              />
            </div>
          </div>

          <div className="form-column">
            <div className="form-group">
              <label htmlFor="ECAcertificateNo">ECA Certificate Number</label>
              <input
                type="text"
                id="ECAcertificateNo"
                value={ecaData.ECAcertificateNo}
                onChange={(e) =>
                  handleECAChange("ECAcertificateNo", e.target.value)
                }
                placeholder="Enter certificate number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="ECAequivalency">ECA Equivalency</label>
              <input
                type="text"
                id="ECAequivalency"
                value={ecaData.ECAequivalency}
                onChange={(e) =>
                  handleECAChange("ECAequivalency", e.target.value)
                }
                placeholder="Enter equivalency code"
              />
            </div>
            <div className="form-group">
              <label htmlFor="ECAequivalency">ECA 2 Equivalency</label>
              <input
                type="text"
                id="ECA2equivalency"
                value={ecaData.ECA2equivalency}
                onChange={(e) =>
                  handleECAChange("ECA2equivalency", e.target.value)
                }
                placeholder="Enter ECA2 equivalency  code"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="education-container">
      <div className="form-header">
        <h1>Education History </h1>
        <p>
          Please provide education, language test, and ECA information for the
          primary applicant and spouse.
        </p>
      </div>

      {loading && (
        <div className="loading-indicator">
          <p>Loading education history data...</p>
        </div>
      )}

      <div className="tab-navigation">
        <button
          className={`tab-btn ${activeTab === "primary" ? "active" : ""}`}
          onClick={() => setActiveTab("primary")}
        >
          Primary Applicant
        </button>
        {spouseExists && (
          <button
            className={`tab-btn ${activeTab === "spouse" ? "active" : ""}`}
            onClick={() => setActiveTab("spouse")}
          >
            Spouse
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {renderForm()}

        <div className="form-footer" style={{ display: "flex", gap: "20px" }}>
          <button
            onClick={() => {
              navigate(-1);
            }}
            type="button"
            className="submit-btn"
            disabled={loading}
          >
            Back
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Saving..." : "Save and Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EducationHistory;
